import styled from 'styled-components';
import Select from 'react-select';

export const SectionWrapper = styled.section`
  overflow: hidden;
  min-height: 40rem;
`;

export const FilterWrapper = styled.div`
  width: 100vw;
  height: fit-content;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  padding: 1rem 2.5rem 1.5rem;
  background-color: #f5f5f5;
  margin-bottom: 2rem;
`;

export const FilterContainer = styled.div`
  width: 100%;
  max-width: 33.75rem;
  height: fit-content;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;

  @media (min-width: 992px) {
    max-width: 62rem;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
  }
  @media (min-width: 1200px) {
    max-width: 75rem;
  }
`;

export const FilterTitle = styled.h2`
  margin: 0.675rem 0;
  padding: 0;
  font-size: ${({ isArabic }) => (isArabic ? '0.875rem' : '1rem')};
  text-align: ${({ isArabic }) => (isArabic ? 'right' : 'left')};
  font-family: ${({ isArabic }) =>
    isArabic ? 'GESSTwoDWTCLight,sans-serif!important' : 'LibreBaskervilleRegular'};
  color: ${({ isArabic }) => (isArabic ? '#898989' : '')};
  margin-bottom: ${({ isArabic }) => (isArabic ? '0px' : '')};
  @media (min-width: 992px) {
    width: 100%;
  }
`;

export const FilterSelect = styled(Select)`
  width: 100%;
  height: 3.125rem;
  margin: 0.625rem 0;
  outline: none;

  @media (min-width: 992px) {
    max-width: 11.125rem;
    ${({ isArabic }) => (isArabic ? 'margin-left: 1.5rem;' : 'margin-right: 1.5rem;')}
  }
  @media (min-width: 1200px) {
    max-width: 18.625rem;
  }

  .dropdown__control {
    width: 100%;
    height: 3.125rem;
    box-shadow: none;
    outline: none;
    text-align: left;
    line-height: 1.5;
    text-align: ${({ isArabic }) => (isArabic ? 'right' : 'left')};
    font-family: ${({ isArabic }) => (isArabic ? 'GESSTwoDWTCMedium' : 'DINRegular')};
    font-size: ${({ isArabic }) => (isArabic ? '10px' : '0.875rem')};
    caret-color: transparent;
    padding: 0 1rem;
    border: 1px solid ${({ isOpen }) => (isOpen ? '#dae0e5' : 'transparent')};
    cursor: pointer;
    background-color: #fff;
    &:hover {
      border: 1px solid #dae0e5;
    }

    &:after {
      content: '';
      margin-left: ${({ isArabic }) => (isArabic ? '0' : '1rem')};
      margin-right: ${({ isArabic }) => (isArabic ? '1rem' : '0')};
      display: inline-block;
      margin-bottom: 3px;
      width: 0;
      height: 0;
      border: solid #000;
      border-width: 0 2px 2px 0;
      padding: 3px;
      animation-name: ${({ isOpen }) => (isOpen ? 'arrow-up' : 'arrow-down')};
      animation-duration: 300ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
    }

    @keyframes arrow-up {
      from {
        transform: rotate(-315deg);
      }
      to {
        transform: rotate(-135deg);
      }
    }

    @keyframes arrow-down {
      from {
        transform: rotate(-135deg);
      }
      to {
        transform: rotate(45deg);
      }
    }
  }
  .dropdown__indicator-separator,
  .dropdown__indicator {
    display: none;
  }
  .dropdown__menu {
    width: 100%;
    height: auto;
    box-shadow: none;
    border: 1px solid #dae0e5;
    position: absolute;
    top: 3.25rem;
    margin: 0;
    background-color: #fff;
    ${({ isOpen }) =>
      isOpen
        ? `
      animation-name: fade-in;
      animation-duration: 300ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `
        : `
      animation-name: fade-out;
      animation-duration: 300ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `}
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fade-out {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .dropdown__menu-list {
    padding: 0;
    width: 100%;
    height: 100%;
    max-height: 20rem;
  }
  .dropdown__option {
    width: 100%;
    height: 1.75rem;
    margin: 0.75rem auto;
    font-size: ${({ isArabic }) => (isArabic ? '0.75rem' : '0.875rem')};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #212529;
    background-color: #fff;
    padding: 0 1.25rem;
    cursor: pointer;
    &:active,
    &:focus {
      background-color: #fff;
    }
    &:hover {
      background-color: #f8f9fa;
      color: #1b7bdd;
    }
  }

  .selected-option {
    color: #fff !important;
    background-color: #1b7bdd !important;
  }

  .dropdown__single-value,
  .dropdown__placeholder {
    color: ${({ isOpen }) => (!isOpen ? '#898989' : '#898989')} !important;
  }
  .dropdown__value-container {
    padding: 0;
  }
`;

export const FilterSearchButton = styled.button`
  background-color: #1b7bdd;
  color: #fff;
  line-height: 1.5;
  font-family: ${({ isArabic }) => (isArabic ? 'GESSTwoDWTCMedium' : 'DINRegular')};
  font-size: ${({ isArabic }) => (isArabic ? '0.75rem' : '0.875rem')};
  padding: 0.625rem 1.5rem;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  min-width: 13.4375rem;
  width: 100%;
  text-transform: uppercase;
  border-radius: 1.25rem;
  margin: 0.625rem 0;
  border: none;
  outline: none;

  @media (min-width: 576px) {
    width: 13.4375rem;
  }

  &:hover {
    background-color: #165ca3;
  }
`;

export const FilterResultMessage = styled.span`
  font-family: ${({ isArabic }) => (isArabic ? 'GESSTwoDWTCLight' : 'DINRegular')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  flex-direction: row-reverse;
  font-weight: 400;
  width: 100%;
  text-align: center;
  font-size: 1rem;
  margin-bottom: 1rem;
`;
